<template lang="pug">
.go-top(
  v-show="visible"
  @click="scrollToTop"
)
  svg-icon(iconClass="arrow_bottom_g")
  span 回頁頂
</template>

<script>
export default {
  name: "GoTop",
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.visible = document.documentElement.scrollTop > 200;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss" scoped>
.go-top {
  // position: fixed;
  // right: 15px;
  // bottom: 150px;
  // bottom: 3vw;
  // z-index: 8;
  display: flex;
  background: $color_blue_quick_ci;
  @include size(67px, 66px);
  font-size: 14px;
  text-align: center;
  color: $color_white;
  cursor: pointer;
  box-shadow: 1px 3px 3px 0 rgba(0, 0, 0, 0.1);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  border-radius: 8px;
  margin-top:20px;
  @media (max-width: 1024px) {
    bottom: 15px;
  }
  @media (max-width: 991px) {
    @include size(56px, 55px);
    font-size: 12px;
    // bottom: 19vw;
    bottom: 50vw;
  }
  @media (max-width: 420px) {
    bottom: 22.5vw;
  }

  svg {
    transform: rotate(180deg);
    transition: all 0.3s ease-in-out;
  }
}
// .go-top:hover {
//   background: #005BAC;
// }
</style>